//import { combineReducers } from 'redux-immutable';
import { handleActions } from 'redux-actions';
import { Map } from 'immutable';
import { fromJS } from 'immutable';

import actions from '@synergycms_app/store/actions';

//REDUCERS
const hotelsActions = actions.hotels;
const hotels = handleActions(
  {
    [hotelsActions.info.get.toString()]: (hotels, action) => {
      return hotels.set('hotels_info', fromJS(action.payload));
    }
  },
  Map()
);

export default hotels;
//REDUCERS
//export default combineReducers({ hotel }, Record({ hotel: undefined }));
